import React from "react";

const delays = ["delay-0", "delay-200", "delay-400"] as const;

export const TypingIndicator: React.FC = () => {
  return (
    <div className="flex items-center gap-1 h-4">
      {delays.map((delay, idx) => (
        <span
          key={idx}
          className={`w-2 h-2 bg-gray-400 rounded-full animate-bounce-dots ${delay}`}
        />
      ))}
    </div>
  );
};
